import React from 'react';

const Footer = () => {
  return (
    <footer className="footer" style={{ backgroundColor: '#f5f5f5', padding: '1rem 0' }}>
      <div className="content has-text-centered">
        <div className="footer-links">
          <a 
            href="https://injee.codeberg.page/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Injee
          </a>
          <span className="footer-separator"> | </span>
          <a 
            href="https://injee.codeberg.page/docs/#/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Docs
          </a>
          <span className="footer-separator"> | </span>
          <a 
            href="https://codeberg.org/injee" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Code
          </a>
          <span className="footer-separator"> | </span>
          <a 
            href="https://paypal.me/mindaslab" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Donate
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;